import { useState, useEffect } from "react";
import { getLive } from "../../network/lib/computer.js";
import { handleContent } from "../utils/helper.js";
import parse from "html-react-parser";
import compBackImg from "../../assests/images/computer/ComputerLab.jpg";

function ComputerDetails() {
  const [computerDetails, setComputerDetails] = useState();

  useEffect(() => {
    !computerDetails && populateComputerDetails();
  }, []);

  function populateComputerDetails() {
    getLive().then((res) => {
      if (res.status == 200) {
        setComputerDetails(res.data);
      }
    });
  }

  const contents = computerDetails && (
    <div className="Row">
      <div className="Cell" style={{ textAlign: "left", backgroundImage: `url(${compBackImg})`,border: '3px solid #fe6902', borderRadius: '40px', 
                                backgroundRepeat: 'repeat-y',backgroundPosition :'right', padding:"10px 25px"}}>
        <div style={ { paddingLeft: '10px', color: 'black',}}>
          <table
            cellSpacing="0"
            style={{ width: "797px", borderCollapse: "collapse" }}
          >
            <tbody>
              <tr>
                <th scope="col">&nbsp;</th>
              </tr>
              {computerDetails.map((computerDetail) => (
                <tr key={computerDetail.id}>
                  <td>
                    {parse(
                      `<span class="headings">${computerDetail.heading}</span>`
                    )}
                    {computerDetail.image &&
                      parse(
                        `<img src=${computerDetail.image} style="float: right;width: 350px"/>`
                      )}
                    {parse(
                      handleContent(
                        computerDetail.contentTypeId,
                        computerDetail.content
                      )
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );

  return contents;
}

export default ComputerDetails;
